/// <summary>
/// ライセンスシリアル定義(ブラウザ用)
/// </summary>
/// <remarks>
/// この定義はブラウザーで利用してください。
/// 意図的に EMsSr2 の値と異なる値にしています。
/// </remarks>

export enum FunctionBit {
    Function_Invalid = -1,                  // (無効値)
    FunctionCld_SaaS = 0,                   // Skyクラウド(SaaS)
    FunctionAlt_Ast = 1,                    // 資産情報アラート
    FunctionAlt_Log = 2,                    // ログアラート
    FunctionAst_AgRunState = 3,             // 端末機稼働状況
    FunctionAst_AppSetup = 4,               // アプリケーションインストール状況
    FunctionAst_DispWLANSet = 5,            // 無線LAN利用設定・詳細設定表示
    FunctionAst_Https = 6,                  // HTTP(S)機能
    FunctionAst_ModifyAsset = 7,            // 資産変更状況
    FunctionAst_OSLicense = 8,              // ＯＳライセンス状況
    FunctionAst_OfficeSetup = 9,            // Officeインストール状況
    FunctionAst_VirusChecker = 10,          // ウイルス対策ソフトインストール状況
    FunctionAst_WinPatch = 11,              // Windows更新プログラム適用状況
    FunctionLog_AgLogonoff = 12,            // 端末機ログオン/ログオフ日時ログ
    FunctionLog_AgOperation = 13,           // 端末機操作ログ
    FunctionLog_Application = 14,           // アプリケーションログ
    FunctionLog_FileOperation = 15,         // ファイル操作ログ
    FunctionLog_Printer = 16,               // プリンタ出力ログ
    FunctionLog_Removable = 17,             // 外部記憶媒体
    FunctionLog_SendMail = 18,              // 送信メールログ
    FunctionLog_System = 19,                // システムログ
    FunctionLog_TCPSession = 20,            // 想定外TCP通信ログ Ver10.0より
    FunctionLog_WebDownload = 21,           // Ｗｅｂ閲覧(Download)ログ
    FunctionMdm_RemoteLockWipe = 22,        // リモートロックワイプ
    FunctionOth_Cloud_BYOK = 23,            // BYOK(クラウドS系/M系専用)
    FunctionPat_Software = 24,              // ソフトウェア配布
    FunctionExt_LimitOptionAssets = 25,     // [特殊]資産限定OP. オンプレライセンスにこのビットはないが、M1ブラウザ上のみ特別に用意。(システムログがなくても一部システムログを表示する必要があるため)
    FunctionOth_PCConditionCheck = 26,      // PC環境診断
    FunctionLog_M365Link = 27,              // M365監査ログ
    FunctionLog_M365LinkMail = 28,          // M365監査ログメールOP
    FunctionCtl_VirusNwInsulation = 29,     // ウィルス対策ソフトウェア連携ネットワーク遮断
    FunctionOp_EDRPlusPack_Yarai = 30,      // EDRプラスパック(Yarai)
    FunctionAst_WindowsUpdateManagement = 31,   // 更新プログラム配布管理
    Function_DefCount = 32,	                //(定義数) ※負値定義以外
}

// ライセンス情報
// ※SCV\SaaS\Web\CtlSvr_Cloud\CtlSvr_Cloud\Modelsと同じになること
//
// ★★★使用方法★★★
// @/util/LicenseUtil.ts 経由でご利用ください
// 

export class ScvLicenseManager {
    /// iOS端末ライセンス発行数
    tenantIOSLicenseCount = 0;

    /// <summary>
    /// モバイル端末の資産情報があるかどうか
    /// </summary>
    mobileAssetsExists = false;

    /// <summary>
    /// iOS モバイル端末の資産情報があるかどうか
    /// </summary>
    iosMobileAssetsExists = false;

    /// <summary>
    /// Android モバイル端末の資産情報があるかどうか
    /// </summary>
    androidMobileAssetsExists = false;

    /// <summary>
    /// SKYDIV リモートアクセスサービスライセンス 接続端末発行数
    /// </summary>
    sdvRemoteAccessAgentCount = 0;

	/// <summary>
    /// オプション機能ビット
    /// </summary>
    optionBit = 0;

    /// <summary>
    /// 紛失端末制御用サーバーの認証ファイルが登録されているかどうか
    /// </summary>
    registedMDMServer = false;

    /// <summary>
    /// MDMオプション機能ビット
    /// </summary>
    emmOptionBit = 0;

    /// <summary>
    /// ライセンスシリアルビット(文字列) 初期値はver20.3までの固定値
    /// </summary>
    functionBit = "20971359";

    /// <summary>
    /// ロール
    /// </summary>
    roleType = 0;

    /// <summary>
    /// アカウント最大数
    /// </summary>
    accountMax = 50;

    /// <summary>
    /// 部署ID
    /// </summary>
    divisionId = 2;

    /// <summary>
    /// 部署名
    /// </summary>
    divisionName = "";

    /// <summary>
    /// 閲覧部署ID
    /// </summary>
    managementDivisionIDList = new Array<number>(0);

    /// <summary>
    /// 機能制限
    /// </summary>
    mgrRestriction = "";

    /// <summary>
    /// BitLocker回復キー有無
    /// </summary>
    existsBitLocker = false;

    /**
     * @brief	iOSモバイルのチェックが付いているかチェック
     * @return	なし
     */
    public isCheckMobileiOS(): boolean {
        if (((0 != (this.emmOptionBit & 0x0000000000000001)) && (0 < this.tenantIOSLicenseCount))) {
            return true;
        }
        return false;
    }

    /**
     * @brief	iOSモバイル機能有効チェック
     * @return	なし
     */
    public isEnabledMobileiOS(): boolean {
        if (((0 != (this.emmOptionBit & 0x0000000000000001)) && (0 < this.tenantIOSLicenseCount)) || this.iosMobileAssetsExists) {
            return true;
        }
        return false;
    }

    /**
     * @brief	Androidのチェックが付いているかチェック
     * @return	なし
     */
    public isCheckMobileAndroid(): boolean {
        if (((0 != (this.emmOptionBit & 0x0000000000000002)) && (0 < this.tenantIOSLicenseCount))) {
            return true;
        }
        return false;
    }

    /**
     * @brief	Androidモバイル機能有効チェック
     * @return	なし
     */
    public isEnabledMobileAndroid(): boolean {
        if (((0 != (this.emmOptionBit & 0x0000000000000002)) && (0 < this.tenantIOSLicenseCount)) || this.androidMobileAssetsExists) {
            return true;
        }
        return false;
    }


    /**
     * @brief	iOS端末ライセンス数取得
     */
    public getTenantIOSLicenseCount(): number {
        return this.tenantIOSLicenseCount;
    }

    /**
     * @brief	モバイルの位置情報機能有効チェック
     * @return	なし
     */
    public isEnableEmmLocation(): boolean {
        // モバイルライセンスのチェック(iOSまたはAndroid)
        if (this.isCheckMobileiOS() || this.isCheckMobileAndroid())  {
            return true;
        }
        return false;
    }

    /**
     * @brief	紛失制御機能有効チェック
     */
    public isEnabledMDM(): boolean {
        return (0 != (this.optionBit & 0x0000000000000002));		// s_SaaSSrCld_Mdm_RemoteLockWipe
    }

    /**
     * @brief	SKYDIV リモートアクセスサービスライセンス有効チェック
     */
    public isEnabledSDVRemoteAccessService(): boolean {
        return (0 != (this.optionBit & 0x0000000000000001));		// s_SaaSSrCld_SKYDIVRemote
    }

    /**
    * @brief	BYOKライセンス有効チェック
    */
    public isEnabledBYOK() {
        return (0 != (this.optionBit & 0x0000000000000010));		// s_SaaSSrCld_BYOK
    }

    /**
    * @brief	「PC環境診断」ライセンス有効チェック
    */
    public isEnabledPcConditionCheck(): boolean {
        return this.isLicenseEnable(FunctionBit.FunctionOth_PCConditionCheck);
    }

    /**
    * @brief	「ウィルス対策ソフトウェア連携ネットワーク遮断」ライセンス有効チェック
    */
    public isEnabledVirusNwInsulation(): boolean {
        return this.isLicenseEnable(FunctionBit.FunctionCtl_VirusNwInsulation);
    }

    /**
    * @brief	「EDRプラスパック(Yarai)」ライセンス有効チェック
    */
    public isEnabledEDRPlusPack(): boolean {
        return this.isLicenseEnable(FunctionBit.FunctionOp_EDRPlusPack_Yarai);
    }

    /**
    * @brief	M365監査ログライセンス有効チェック
    */
    public isEnabledM365Link(): boolean {
        return this.isLicenseEnable(FunctionBit.FunctionLog_M365Link);
    }
    
    /**
    * @brief	M365監査ログメールOPライセンス有効チェック
    */
    public isEnabledM365LinkMail(): boolean {
        return this.isLicenseEnable(FunctionBit.FunctionLog_M365LinkMail);
    }

    /**
     * @brief	ライセンス機能ビット判定(単一ライセンス)
     * @param   [in]    functionBit 判定するライセンス
     * @returns true: 有効    false: 無効
     */
    public isLicenseEnable(functionBit: FunctionBit): boolean {

        const functionBitData = BigInt(this.functionBit);

        const mask = BigInt(1n << BigInt(functionBit));

        return (functionBitData & mask) !== BigInt(0n);
    }

    /**
     * @brief	ライセンス機能ビット判定(いずれか1つでも有効なら true を返す版)
     * @param   [in]    functionBits 判定するライセンス
     * @returns true: 有効    false: 無効
     */
    public anyLicenseEnableMs(functionBits: Array<FunctionBit>): boolean {

        const functionBitData = BigInt(this.functionBit);
        let mask = 0n;

        functionBits.forEach((functionBit, index) => {
            mask |= BigInt(1n << BigInt(functionBit));
        });

        //const mask = BigInt(1n << BigInt(functionBit));

        return (functionBitData & mask) !== BigInt(0n);
    }

    /**
     * @brief	ライセンス機能ビット判定(すべて有効なら true を返す版)
     * @param   [in]    functionBits 判定するライセンス
     * @returns true: 有効    false: 無効
     */
    public allLicenseEnableMs(functionBits: Array<FunctionBit>): boolean {

        const functionBitData = BigInt(this.functionBit);
        let mask = 0n;

        functionBits.forEach((functionBit, index) => {
            mask |= BigInt(1n << BigInt(functionBit));
        });

        //const mask = BigInt(1n << BigInt(functionBit));

        return (functionBitData & mask) !== mask;
    }
}

